import * as yup from "yup"

export const generalAssetValidation = yup.object().shape({
    transaction_date : yup.string().label("Transaction Date").required(),
    mr_group_id: yup.string().label("Group Asset").required(),
    mr_brand_id: yup.string().label("Brand").required(),
    asset_code: yup.string().label("Transaction Code").required(),
    asset_name : yup.string().label("Description").required(),
    mr_document_id: yup.string().label("Document").required(),
    serial_document : yup.string().label("Serial Document").required(),
    acquisition_cost: yup.number().label("Acquisition Cost").required(),
    acquisition_date: yup.string().label("Acquisition Date").required(),
    depreciation_duration: yup.number().label("Depreciation Duration").required(),   
    depreciation_expired: yup.string().label("Depreciation Expired").required(),
    vendor_id: yup.string().label("Vendor").required(),
    asset_foto: yup.mixed().optional(),
    asset_id: yup.string().label("Asset ID").optional()
});

export type GeneralAssetType = yup.InferType<typeof generalAssetValidation>